import { useFetcher } from "@remix-run/react";
import React, { useState } from "react";
import ReportModal from "./report-modal";

const ReportButton: React.FC<{ contentId: string; contentType: string; className: string }> = ({
  contentId,
  contentType,
  className
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fetcher = useFetcher();

  const handleReportSubmit = async (data: { reason: string; context: string }) => {
    try {

        const formData = new FormData();
        formData.append("type", data.reason);
        formData.append("context", data.context || "");
        formData.append("contentId", contentId);
        formData.append("contentType", contentType);
      
        fetcher.submit(formData, { method: "post", action: "/api/report" });

        alert("Thank you for your report!");
    } catch (error) {
      console.error("Failed to submit report:", error);
      alert("Failed to submit the report. Please try again later.");
    }
  };

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={className}
      >
        Report
      </button>
      <ReportModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleReportSubmit}
      />
    </>
  );
};

export default ReportButton;
